import { getAllegroImpliedWarranties } from '../../../api/allegro/impliedwarranty/impliedWarranty';
import { AllegroImpliedWarranty } from '../../../api/allegro/impliedwarranty/impliedWarrantyTypes';
import { fetchAllPages, swallowUnauthorized } from '../utils';

const PAGE_SIZE = 60;

export default async function fetchAllegroImpliedWarranties(
  marketplaceCode: string,
  signal?: AbortSignal,
): Promise<AllegroImpliedWarranty[]> {
  return swallowUnauthorized(
    () => fetchAllPages(
      async (offset, limit) => {
        const page = await getAllegroImpliedWarranties(marketplaceCode, offset, limit, signal);

        return {
          items: page.impliedWarranties,
          totalCount: page.count,
        };
      },
      PAGE_SIZE,
    ),
    [],
  );
}
